import React from 'react'

export default class SelectModalTabPane extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }

  static defaultProps = {
    prefixCls: 'mkui-modal-tabs-pane'
  }

  componentDidMount(){
  }

  render(){
    let {prefixCls, children} = this.props
    return (
      <div className={prefixCls}>
        {children}
      </div>
    );
  }
}
